module.exports = __webpack_public_path__ + "static/media/client-profile-img.dc716344.png";